// Mercapoli - Trabaja con Nosotros
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft, Bike, Store, Clock, DollarSign, Headphones, Smartphone } from 'lucide-react';
import { Button } from '../../components/ui/button';
import Footer from '../../components/Footer';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const TrabajaConNosotros = () => {
  const beneficiosRider = [
    { icon: <Clock className="h-5 w-5" />, texto: "Horarios flexibles" },
    { icon: <DollarSign className="h-5 w-5" />, texto: "Pagos transparentes" },
    { icon: <Headphones className="h-5 w-5" />, texto: "Soporte y acompañamiento" },
    { icon: <Smartphone className="h-5 w-5" />, texto: "Plataforma fácil de usar" }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Trabaja con Mercapoli | Repartidores y oportunidades</title>
        <meta name="description" content="Únete a Mercapoli como repartidor o aliado y genera ingresos con una plataforma moderna, flexible y segura." />
      </Helmet>

      {/* Header */}
      <header className="border-b border-border">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Mercapoli" className="w-10 h-10" />
              <span className="font-heading text-xl font-bold">Mercapoli</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="py-16 bg-gradient-to-b from-brand-accent/10 to-background">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-6">
            Trabaja con Mercapoli
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Únete a nuestro equipo y genera ingresos con flexibilidad
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <p className="text-lg text-center mb-16">
            En Mercapoli creemos en crear <strong>oportunidades reales</strong> para personas y negocios.
          </p>

          {/* Repartidores */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-2xl bg-brand-primary flex items-center justify-center">
                <Bike className="h-7 w-7 text-white" />
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold">Repartidores</h2>
                <p className="text-muted-foreground">Conviértete en rider Mercapoli</p>
              </div>
            </div>

            <p className="text-lg mb-6">
              Genera ingresos con horarios flexibles, tecnología moderna y soporte constante.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
              {beneficiosRider.map((beneficio, index) => (
                <div key={index} className="p-4 rounded-xl bg-card border border-border text-center">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-brand-primary/10 flex items-center justify-center text-brand-primary">
                    {beneficio.icon}
                  </div>
                  <p className="text-sm font-medium">{beneficio.texto}</p>
                </div>
              ))}
            </div>

            <Link to="/registro-rider">
              <Button className="bg-brand-primary hover:bg-brand-primary/90" size="lg">
                Quiero ser Rider
              </Button>
            </Link>
          </div>

          {/* Comercios */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-2xl bg-brand-accent flex items-center justify-center">
                <Store className="h-7 w-7 text-black" />
              </div>
              <div>
                <h2 className="font-heading text-2xl font-bold">Aliados y Comercios</h2>
                <p className="text-muted-foreground">Haz crecer tu negocio con nosotros</p>
              </div>
            </div>

            <p className="text-lg mb-6">
              Si eres comercio, proveedor o profesional, Mercapoli te ofrece un ecosistema 
              en crecimiento para desarrollar tu potencial y llegar a miles de clientes.
            </p>

            <Link to="/registro-comercio">
              <Button variant="outline" size="lg">
                Registrar mi Comercio
              </Button>
            </Link>
          </div>

          {/* CTA */}
          <div className="text-center py-12 bg-gradient-to-r from-brand-primary/10 via-brand-accent/10 to-brand-primary/10 rounded-3xl">
            <p className="text-2xl font-heading font-bold text-brand-primary">
              Forma parte del movimiento Mercapoli
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TrabajaConNosotros;
